/**
 * Launch flags.
 *
 * Local (trip_type 1), Rental (trip_type 2) and Outstation (trip_type 3) are all
 * live. Outstation uses real ZeniaFleets backend rates (fleets.zeniafleets.com)
 * only. Local and Rental use a FALLBACK MERGE in store/Cab/CabAction.js: every
 * real backend fare is kept, and only the cab types the backend does not yet
 * price are filled with placeholder tempRates, so all three options always show.
 * As the backend gains real Hatchback/SUV rates they replace the placeholders
 * automatically.
 *
 * These flags remain as a fast kill switch: set one back to true to drop that
 * product to a "Coming soon" state on the booking widget without a code change.
 */
export const COMING_SOON = {
  local: false,
  rental: false,
}

export const isComingSoon = (tripType) =>
  (tripType === 1 && COMING_SOON.local) || (tripType === 2 && COMING_SOON.rental)
